// src/components/DataTable.js
import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { useParams } from 'react-router-dom';

import { API_URL, ENDPOINTS } from '../../constants/api';
import { decodeToken, getToken } from '../../utils/TokenUtils';
import HorizontalForm from '../../components/HorizontalForm';
import { CURRENT_DATE, FIRST_DAY_OF_MONTH } from '../../constants';
import DataEntryTable from '../../components/EntryTable';

const MultiEntryForm = () => {
  const [report, setReport] = useState([]);
  const [reportHeader, setReportHeader] = useState([]);
  const [reportFooter, setReportFooter] = useState([]);

  const token = getToken();
  const userId = decodeToken(token, 'id');

  const [loading, setLoading] = useState(true);
  const { route } = useParams(); // Retrieve the param from the URL

  const [link, setLink] = useState([]);
  const [inputs, setInputs] = useState([]);
  const [values, setValues] = useState([]);

  const [executionTime, setExecutionTime] = useState(null);

  useEffect(() => {
    setReport([]);
    const url = `${API_URL}/${ENDPOINTS.SYS}/createform/${route}`;
    // console.log('url:', url);
    const fetchForm = async () => {
      const initialState = {};
      try {
        const response = await axios.get(url, {
          headers: {
            Authorization: token ? `Bearer ${token}` : '',
          },
        });
        setLink(response.data.link);
        // console.log('link:', response.data.link)
        setInputs(response.data.inputs);
        //Loop through form inputs and create initial key values form inputs
        response.data.inputs.map((input) => {
          if (input.type === 'file') {
            initialState[input.name] = null;
          } else if (
            input.type === 'dropdown' ||
            input.type === 'load-dropdown' ||
            input.type === 'enum-dropdown'
          ) {
            initialState[input.name] = '%';
          } else if (
            input.type === 'date' &&
            input.name === 'from' &&
            input.value === 'first_day_of_month'
          ) {
            initialState[input.name] = FIRST_DAY_OF_MONTH;
          } else if (input.type === 'date' && input.name === 'to') {
            initialState[input.name] = CURRENT_DATE;
          } else if (input.type === 'hidden-user') {
            initialState[input.name] = userId;
          } else {
            initialState[input.name] = input.value.trim();
          }
        });

        //add default values for user_id and date
        //  initialState['user_id'] = userId;
        //  initialState['to'] = CURRENT_DATE;
        //Set all initial input values to the state values
        setValues(initialState);

        setLoading(false);
        // document.title = response.data.link.page_title; // Update title dynamically
      } catch (error) {
        console.error('Error fetching data:', error);
        setLink([]);
        setInputs([]);
        setLoading(false);
      }
    };

    fetchForm();
  }, [route]);

  //console.log('inputs:', inputs);
  return (
    <>
      <HorizontalForm
        token={token}
        link={link}
        values={values}
        inputs={inputs}
        setInputs={setInputs}
        setData={setReport}
        setReportHeader={setReportHeader}
        setReportFooter={setReportFooter}
        setValues={setValues}
        setExecutionTime={setExecutionTime}
      />

      {/* {report && report.length === 0 && 
        <p>No Data </p>
      }  */}

      {report && report.length > 0 && (
        <DataEntryTable
          data={report}
          reportHeader={reportHeader}
          reportFooter={reportFooter}
          link={link}
          token={token}
          executionTime={executionTime}
          setData={setReport}
        />
      )}
    </>
  );
};

export default MultiEntryForm;
